export const SPECIALIST = 'SPECIALIST';
export const USER = 'USER';
export const GLOBAL = 'GLOBAL';
